var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0C7.61175 0 0 7.61175 0 17C0 26.3882 7.61175 34 17 34C26.3882 34 34 26.3882 34 17C34 7.61175 26.3882 0 17 0ZM14.1199 22.6808C14.9189 20.1464 16.4319 17.1105 16.6997 16.3427C17.0864 15.2277 16.4007 14.7333 14.2347 16.6388L13.753 15.7321C16.2237 13.0447 21.3109 12.4369 19.5798 16.6005C18.4988 19.2001 17.7253 20.9553 17.2833 22.3097C16.6388 24.2831 18.2665 23.4827 19.8602 22.0107C20.077 22.3649 20.1478 22.4797 20.3646 22.8877C16.8258 26.2565 12.8973 26.554 14.1199 22.6808ZM20.8377 11.1081C20.0841 11.7498 18.9677 11.7357 18.343 11.0769C17.7183 10.4182 17.8231 9.36558 18.5753 8.72383C19.329 8.08208 20.4453 8.09767 21.0701 8.755C21.692 9.41517 21.59 10.4677 20.8377 11.1081Z",
    fill: "#255056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoblack);
export default __webpack_public_path__ + "static/media/info.black.02672851d5a3eb30ea2cffab811b9f1b.svg";
export { ForwardRef as ReactComponent };